// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5532) return "static/chunks/5532.81bbd3b2163be332.js";
	if (chunkId === 9504) return "static/chunks/panel-brand-list.ada202b063a4ce72.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1168":"53fb580f8d0e8bcf","2300":"814517455e39b62e","9155":"aa6576e19bff3c6d"}[chunkId] + ".js";
};